module.exports = __webpack_public_path__ + "static/pizza26-445bc4d58ec52340109c681b39a129e3.webp";